<nav [ngClass]="menuService.showSideBar ? 'w-[60px]' : 'w-[60px]'"
  class="scrollbar-thumb-rounded scrollbar-track-rounded hidden h-full flex-col justify-between overflow-auto transition-all duration-300 scrollbar-thin scrollbar-track-transparent scrollbar-thumb-card lg:flex">
  <div class="">
    <div *ngFor="let menu of menuService.pagesMenu">
      <ul class="flex flex-col space-y-1">
        <!-- List items -->
        <li class="py-1" *ngFor="let item of menu.items">
          <!-- Menu List -->
          <div (click)="$event.stopPropagation(); toggleMenu(item)"
            class="group relative text-muted-foreground ms-2 w-[40px] h-[40px]">
            <!-- Icon -->
            <div [ngClass]="item.active && !menuService.showSideBar ? 'text-primary' : 'text-muted-foreground'"
              class="pointer-events-none absolute m-2">
              <svg-icon *ngIf="item.icon" src="{{ item.icon }}" [applyClass]="true"
                class="{{item.active && !menuService.showSideBar ? 'text-primary' : 'text-muted-foreground'}}"
                [svgClass]="'h-6 w-6'"> </svg-icon>
              <mat-icon *ngIf="item.matIcon" class="material-icons-outlined">{{ item.matIcon }}</mat-icon>
            </div>

            <!-- Condition -->
            <ng-container [ngTemplateOutlet]="item.children ? childMenu : parentMenu"
              [ngTemplateOutletContext]="{ item: item }">
            </ng-container>

            <ng-template #parentMenu let-item="item">
              <div routerLink="{{ item.route }}"
                class="flex h-9 cursor-pointer items-center justify-start rounded text-muted-foreground hover:bg-card hover:text-foreground">
                <!-- parentMenu -->
              </div>
            </ng-template>

            <ng-template #childMenu let-item="item">
              <div class="flex h-9 cursor-pointer items-center justify-start rounded hover:bg-card"
                (click)="onNavigateUrl(item)">
                <!-- childMenu -->
                <!-- <a [routerLink]="item.route" routerLinkActive="text-primary" [routerLinkActiveOptions]="{ exact: true }"
                  class="inline-block w-full px-4 py-2 text-md font-semibold"></a> -->
              </div>
            </ng-template>

            <div class="fixed w-full">
              <span
                class="z-[100] absolute left-14 -top-[34px] w-auto min-w-max origin-left scale-0 rounded-md bg-foreground p-2 text-xs font-bold text-background shadow-md transition-all duration-200 group-hover:scale-100">
                {{ item.label | translate }}
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>

  <div class="mx-4 my-4 space-y-1">
    <a target="_blank" href=""
      class="group flex h-9 cursor-pointer items-center justify-start rounded p-2 hover:bg-card">
      <div class="fixed w-full">
        <span
          class="z-[100] absolute left-14 -top-[34px] w-auto min-w-max origin-left scale-0 rounded-md bg-foreground p-2 text-xs font-bold text-background shadow-md transition-all duration-200 group-hover:scale-100">
          v{{ appJson.version }}
        </span>
      </div>
    </a>
  </div>
</nav>